import type { IGetCargoTripRes, TripStatusType } from 'api/swagger';
import { useAddCargoToActiveTrip } from 'api/trips/use-add-cargo-to-active-trip';
import { useAddCargoToTrip } from 'api/trips/use-add-cargos-to-trip';
import { useSelectCargoStore } from 'shared/stores/use-select-cargos';
import type { IPendingTripData } from './types';

interface IAddToTripParams {
  tripId: number;
  tripStatus: TripStatusType;
  cargoTrips?: IGetCargoTripRes[];
}

export const useAddCargoToTripFlow = () => {
  const { selectedCargos, selectedCargoItems, cargosWithSelection, deleteAll } = useSelectCargoStore();

  const { mutateAsync: addCargosToTrip, isLoading: isAddingToTrip } = useAddCargoToTrip();
  const { mutateAsync: addCargoToActiveTrip, isLoading: isAddingToActiveTrip } = useAddCargoToActiveTrip();

  const isLoading = isAddingToTrip || isAddingToActiveTrip;

  const addToTrip = async (params: IAddToTripParams): Promise<IPendingTripData | null> => {
    const { tripId, tripStatus, cargoTrips } = params;

    const isSingleCargo = cargosWithSelection.size === 1;
    const isActiveTripFlow = isSingleCargo && tripStatus !== 'planning';

    if (isActiveTripFlow) {
      const cargoIdForLookup = Array.from(cargosWithSelection.keys())[0];

      const cargoId = Array.from(selectedCargos.keys())[0];
      const cargoItemIds = cargoId ? [] : Array.from(selectedCargoItems.keys());

      const existingCargoTrip = cargoTrips?.find((cargoTrip) => cargoTrip.cargoId === cargoIdForLookup);

      if (existingCargoTrip) {
        await addCargoToActiveTrip({
          tripId,
          data: { cargoId, cargoItemIds, tripTasks: [] },
        });
        deleteAll();
        return null;
      }

      return { tripId, cargoId, cargoItemIds };
    }

    await addCargosToTrip({
      tripId,
      cargoIds: Array.from(selectedCargos.keys()),
      cargoItemIds: Array.from(selectedCargoItems.keys()),
    });
    deleteAll();
    return null;
  };

  return { addToTrip, isLoading };
};
